var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-container",
    {
      attrs: {
        fluid: ""
      }
    },
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" What to Expect ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          " If you already have a website at another hosting provider, GreenGeeks offers its customers a free migration by our professional site migration team. "
                        )
                      ]),
                      _c("p", [
                        _vm._v(
                          " We'll ask you to provide a few details about your previous hosting account, so we can login to access the existing content in order to copy it over to your GreenGeeks account. "
                        )
                      ])
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [_c("h4", [_vm._v("How Long Does It Take?")])]
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          " Once the migration request form has been completed, our team will review your request and process your migration on a first come, first serve basis. The average turnaround time is 24 to 48 hours. "
                        )
                      ])
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [_c("h4", [_vm._v("More Information")])]
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("p", [
                        _vm._v(" Refer to our "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://www.greengeeks.com/website-transfer",
                              target: "_blank"
                            }
                          },
                          [_vm._v("Website Transfer Guide")]
                        ),
                        _vm._v(" for more information. ")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }